Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.KeywordsFilterGroupView extends Backbone.View
  tagName: 'td'
  template: JST["backbone/templates/monitoring/filters/keywords/keywords_filter_group"]

  initialize: (@options = {}) ->
    @id = @options.id
    @selectedItems = @options.selectedItems || []
    @title = @options.title
    @logic = @options.logic

  render: ->
    @$el.html(@template(@))
    @renderSelector()
    @renderSelectedList()
    @

  renderSelector: ->
    @selectorView = new Monitoring.Views.SocialContents.Filters.TextSelectorView({
      placeholder: I18n.t('monitoring.dashboard.filters.keywords.placeholder')
      buttonLabel: I18n.t('monitoring.dashboard.filters.keywords.add')
    })
    @$el.find('#selector').append(@selectorView.render().el)
    @listenTo(@selectorView, 'newText', @onAddItem)

  renderSelectedList: ->
    @selectedListView = new Monitoring.Views.SocialContents.Filters.SelectedListView({
      selectedItems: @selectedItems
      selectedLogic: @logic
    })
    # @$el.find('#tag-list').append(@selectedListView.render().el)
    @$el.append(@selectedListView.render().el)
    @listenTo(@selectedListView, 'removeItem', @onRemoveItem)
    @listenTo(@selectedListView, 'changeLogic', @onChangeLogic)
    @listenTo(@selectedListView, 'clearSelectedItems', @clearSelectedItems)

  onAddItem: (enteredText) ->
    @trigger('KeywordsFilterGroupView:onChange')
    enteredKeywords = @remove_spaces(enteredText)
    _.each(enteredKeywords, (keyword) =>
      item = {
        code: keyword
        name: keyword
      }
      unless _.contains(_.pluck(@selectedItems, 'code'), item.code)
        @selectedItems.push(item)
    )
    @render()

  onRemoveItem: (itemCode) ->
    @trigger('KeywordsFilterGroupView:onChange')
    @selectedItems = _.filter(@selectedItems, (item) -> item.code != itemCode)
    @render()

  onChangeLogic: (newLogic) ->
    @trigger('KeywordsFilterGroupView:onChange')
    @logic = newLogic
    @render()

  clearSelectedItems: ->
    @trigger('KeywordsFilterGroupView:onChange')
    @selectedItems = []
    @render()

  remove_spaces: (enteredText) ->
    final_keywords = []
    without_spaces = _.map(enteredText.split(','), (s) -> s.trim())
    for keyword in without_spaces
      if keyword !=""
        final_keywords.push(keyword)
    return final_keywords
